module.exports = __webpack_public_path__ + "img/a7f7144.jpg";